import React, { useState } from "react"
import CountUp from "react-countup"
import VisibilitySensor from "react-visibility-sensor"
import styled from "@emotion/styled"

const FigureText = styled.h3`
  font-size: 3rem;
  color: ${props => props.theme.shade[100]};
`

const Ticker = (props, { className, ...rest }) => {
  const [viewPortEntered, setViewPortEntered] = useState(false)

  return (
    <CountUp
      end={props.figure}
      separator=","
      prefix={props.prefix}
      suffix={props.suffix}
      start={viewPortEntered ? null : 0}
    >
      {({ countUpRef }) => {
        return (
          <VisibilitySensor
            active={!viewPortEntered}
            onChange={isVisible => {
              if (isVisible) {
                setViewPortEntered(true)
              }
            }}
            delayedCall
          >
            <FigureText className={className} ref={countUpRef} />
          </VisibilitySensor>
        )
      }}
    </CountUp>
  )
}

export default Ticker
